import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import { SERVICE_CHARGE_RATE, ORDER_STATUS, PACKAGE_INFO } from 'src/utils/constant'
import { useCustomTranslation } from 'src/hooks'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    label: {
      color: theme.palette.grey[400],
      fontSize: theme.typography.body2.fontSize,
    },
    itemValue: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.grey[800],
    },
  }),
)

const OrderDialogContent = ({ orderInfo }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [tB] = useCustomTranslation()

  const status = orderInfo?.payStatus
  if (!orderInfo) return null

  return (
    <Box fontSize="body2.fontSize" mb={2}>
      {/* {orderInfo?.payPrice} */}
      <Box mb={1}>
        <Box className={classes.label}>{t('glossary.order_id')}</Box>
        <Box className={classes.itemValue}>{orderInfo?.orderNumber}</Box>
      </Box>
      <Box mb={1}>
        <Box className={classes.label}>{t('glossary.appointment_info')}</Box>
        <Box className={classes.itemValue}>
          {orderInfo?.[tB('testCenterName')]}
          <br />
          {orderInfo?.[tB('doctorName')]} {orderInfo?.[tB('doctorTitle')]}
          {t('glossary.doctor')}
        </Box>
      </Box>
      <Box mb={1}>
        <Box className={classes.label}>{t('glossary.booker')}</Box>
        <Box className={classes.itemValue}>{orderInfo?.userName}</Box>
      </Box>
      <Box mb={1}>
        <Box className={classes.label}>{t('form.appointment_program')}</Box>
        <Box className={classes.itemValue}>{t(PACKAGE_INFO[orderInfo?.package].title)}</Box>
      </Box>
      <Box mb={1}>
        <Box className={classes.label}>{t('glossary.appointment_time')}</Box>
        <Box className={classes.itemValue}>
          {orderInfo?.appointmentDate} {orderInfo?.appointmentTime}
        </Box>
      </Box>
      <>
        <Box mb={1}>
          <Box className={classes.label}>{t('glossary.amount')}</Box>
          <Box className={classes.itemValue}>
            <ENumberFormat value={orderInfo?.price} currency={orderInfo?.currency} />
          </Box>
        </Box>
        {orderInfo.promotionCode && (
          <Box mb={1}>
            <Box className={classes.label}> {t('glossary.promotion_code')}</Box>
            <Box className={classes.itemValue}>
              {orderInfo?.promotionCode}
              {/* {orderInfo?.promotionAmount || ''} */}
            </Box>
          </Box>
        )}
        {status === ORDER_STATUS.PAID && orderInfo?.price - (orderInfo?.payPrice || 0) !== 0 && (
          <Box mb={1}>
            <Box className={classes.label}>{t('glossary.offer_amount')}</Box>
            <Box className={classes.itemValue}>
              <ENumberFormat
                color="secondary.main"
                value={orderInfo?.price - (orderInfo?.payPrice || 0)}
                currency={orderInfo?.currency}
              />
            </Box>
          </Box>
        )}
        {status === ORDER_STATUS.PAID && orderInfo?.price - (orderInfo?.payPrice || 0) !== 0 && (
          <Box mb={1}>
            <Box className={classes.label}>{t('glossary.price_after_discount')}</Box>
            <Box className={classes.itemValue}>
              <ENumberFormat value={orderInfo?.payPrice} currency={orderInfo.currency} />
            </Box>
          </Box>
        )}
      </>

      {status === ORDER_STATUS.PAID && (
        <Box mb={1}>
          <Box className={classes.label}>{t('glossary.refund_amount')}</Box>
          <Box className={classes.itemValue}>
            <ENumberFormat
              color="secondary.main"
              value={
                orderInfo.payMethod === 'Atome'
                  ? orderInfo.payPrice
                  : orderInfo?.payPrice *
                    (1 - (orderInfo?.refundOrigin || status === 1 ? SERVICE_CHARGE_RATE : 0))
              }
              currency={orderInfo?.currency}
            />
          </Box>
        </Box>
      )}
      {status !== ORDER_STATUS.PENDING_PAYMENT && (
        <Box mb={1}>
          <Box color="secondary.main" mb={0.5}>
            {t('tips.main_tips')}
          </Box>
          <Box fontWeight="fontWeightMedium" fontSize="body1.fontSize" color="secondary.main">
            {t('tips.refund_tips_list.0')}
          </Box>
        </Box>
      )}
    </Box>
  )
}
export default OrderDialogContent
